import { useEffect, useState } from "react";
import { useApp } from "../../../hooks/AppProvider";
import { Table, TeacherColorCell } from "../../../components/BasicComponents";

function GameList({ attributions }) {
    return (
        <>
        <Table headers={["Nom du jeu", "Attributions"]}>
            {attributions.map(data => (<GameViewRow gameName={data.gameName} students={data.students} />))}
        </Table>
        </>
    );

}

function GameViewRow({ gameName, students}) {    
    return (
        <>
        <tr>
            <td>
                {gameName}
            </td>
            <td>
                <InnerTableCell students={students} />
            </td>
        </tr>
        </>
    )
}

function InnerTableCell({ students }) {
    return (
        <table>
            <tbody>
                {students.map(data => (
                    <>
                        <tr>
                            <td>{data.studentName}</td>
                                <TeacherColorCell name={data.teacherName} color={data.teacherColor} />
                        </tr>    
                    </>
                ))}
            </tbody>
        </table>
    )
}


function GameView() {
    let app = useApp();

    let [attributions, setAttributions] = useState([]);

    useEffect(() => {
        app.sendGet("/game/list/attributions", data => {
            setAttributions(data);
        });
    }, []);

    function download() {
        app.sendGet("/game/pdf/all", data => {
            app.sendGet(data.link, async (pdfData) => {
                let blob = await pdfData.blob();
                const url = window.URL.createObjectURL(blob);

                let date = new Date();

                const a = document.createElement("a");
                a.href = url;
                console.log();
                
                a.download = "attribution" + "_" + date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear() + ".pdf";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                window.URL.revokeObjectURL(url);
            });
        });
    }

    return (
        <>
        <div className="main-content">
            <h1>Attributions générales</h1>
            <GameList attributions={attributions} />
            {attributions.length > 0 && 
                <div style={{marginTop: "10px", textAlign: "center"}}>
                    <button onClick={download}>Télécharger en PDF</button>
                </div>
            }
        </div>
        </>
    );
}

export default GameView;